<template>
  <div class="vip-container">
    <div class="bg-decoration">
      <div class="bg-circle bg-circle-1"></div>
      <div class="bg-circle bg-circle-2"></div>
      <div class="bg-circle bg-circle-3"></div>
    </div>
    
    <div class="header">
      <div class="header-content">
        <!-- <div class="header-left" @click="goBack">
          <van-icon name="arrow-left" size="22" />
        </div> -->
        <div class="header-center">
          <span class="header-title">VIP会员</span>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="bank-switch-row" v-if="banks.length > 1" @click="showBankSheet = true">
        <span class="bank-switch-label">开通题库</span>
        <span class="bank-switch-value">{{ bankName || '请选择题库' }}</span>
        <van-icon name="arrow-down" size="14" />
      </div>

      <div class="vip-hero animate-fade-in-up">
        <div class="hero-bg"></div>
        <div class="hero-content">
          <div class="vip-icon-wrapper" :class="'vip-icon-' + bankVipTierLevel">
            <van-icon :name="vipIcon" size="40" />
          </div>
          <div class="vip-info">
            <h2 class="vip-title">{{ vipText }}</h2>
            <p class="vip-desc">{{ vipDesc }}</p>
          </div>
          <div class="vip-status" :class="{ 'active': bankVipActive }">
            <van-icon :name="bankVipActive ? 'checked-circle' : 'circle'" size="16" />
            <span>{{ bankVipActive ? '已开通' : '未开通' }}</span>
          </div>
        </div>
        
        <div class="vip-features-preview">
          <div class="preview-item" v-for="(feature, index) in previewFeatures" :key="index">
            <van-icon :name="feature.icon" size="16" />
            <span>{{ feature.text }}</span>
          </div>
        </div>
      </div>

      <div class="section-header animate-fade-in-up" style="animation-delay: 0.1s">
        <h3>VIP会员套餐</h3>
        <span class="section-tip">{{ bankName ? bankName + " · " : "" }}选择等级开通</span>
      </div>

      <div class="packages">
        <div 
          v-for="(pkg, index) in packages" 
          :key="pkg.id"
          class="package-card"
          :class="{ 
            'selected': selectedPackage === pkg.id,
            'current': isPackageCurrent(pkg),
            'disabled': isPackageDisabled(pkg)
          }"
          :style="{ animationDelay: (0.2 + index * 0.1) + 's' }"
          @click="selectPackage(pkg)"
        >
          <div class="package-popular-tag" v-if="pkg.level === 4">最受好评</div>
          <div class="package-header" :class="'pkg-level-' + pkg.level">
            <div class="package-level-badge">
              <van-icon :name="pkg.icon || 'star-o'" size="20" />
              <span>V{{ pkg.level }}</span>
            </div>
            <span class="package-name">{{ pkg.name }}</span>
            <van-tag v-if="isPackageCurrent(pkg)" type="success" size="small" class="current-tag">当前</van-tag>
          </div>
          
          <div class="package-body">
            <div class="package-price-row">
              <span class="currency">¥</span>
              <span class="price">{{ formatPrice(pkg.price) }}</span>
              <span class="original" v-if="pkg.original_price && pkg.original_price > pkg.price">
                ¥{{ formatPrice(pkg.original_price) }}
              </span>
            </div>
            <div class="package-duration">
              <van-icon name="clock-o" size="14" />
              <span>{{ pkg.valid_type === 2 ? '永久有效' : pkg.days + '天' }}</span>
            </div>
          </div>
          
          <div class="package-footer">
            <div class="package-features-mini">
              <span
                v-for="(feat, fi) in packageFeatureTags(pkg)"
                :key="fi"
                class="feature-tag"
              >{{ feat }}</span>
            </div>
            <p v-if="pkg.description" class="package-desc-line">{{ pkg.description }}</p>
          </div>
          
          <!-- <div class="package-select-indicator" v-if="selectedPackage === pkg.id">
            <van-icon name="check" size="20" />
          </div> -->
        </div>
      </div>

      <div class="section-header animate-fade-in-up" style="animation-delay: 0.5s">
        <h3>会员特权</h3>
      </div>

      <div class="privileges-grid">
        <div 
          v-for="(privilege, index) in privileges" 
          :key="index"
          class="privilege-card animate-scale-in"
          :style="{ animationDelay: (0.6 + index * 0.1) + 's' }"
        >
          <div class="privilege-icon" :style="{ background: privilege.bgColor }">
            <van-icon :name="privilege.icon" size="24" :color="privilege.color" />
          </div>
          <h4>{{ privilege.title }}</h4>
          <p>{{ privilege.desc }}</p>
        </div>
      </div>

      <div class="tips-section animate-fade-in-up" style="animation-delay: 0.9s">
        <div class="tips-card">
          <van-icon name="info-o" size="18" color="#fa8c16" />
          <div class="tips-content">
            <p class="tips-title">升级说明</p>
            <p class="tips-text">升级VIP将立即生效，有效期从购买之日起计算</p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-content">
        <div class="total-price" v-if="selectedPackage">
          <span class="label">合计</span>
          <span class="amount">¥{{ selectedPackagePrice }}</span>
        </div>
        <van-button 
          type="primary" 
          block 
          round
          :disabled="!selectedPackage || !canSelectPackage"
          :loading="paying"
          class="buy-btn"
          @click="handleBuy"
        >
          {{ paying ? '支付中...' : (selectedPackage ? '立即开通' : '请选择套餐') }}
        </van-button>
      </div>
    </div>


    <van-action-sheet
      v-model="showBankSheet"
      :actions="bankActions"
      cancel-text="取消"
      close-on-click-action
      @select="onBankSheetSelect"
    />

    <van-toast v-model:show="showToast" :type="toastType" :message="toastMessage" />
  </div>
</template>

<script>
import { Toast } from 'vant'
import { syncOrderPayAfterWxSuccess } from '@/utils/wxpay'
import { resolveBankVipDisplayName, bankEntitlementLevel } from '@/utils/vipDisplay'
export default {
  name: 'Vip',
  data() {
    return {
      bankId: 0,
      bankName: '',
      banks: [],
      maxOwnedLevel: 0,
      bankPurchaseBlocked: false,
      entitlementPackageId: 0,
      showBankSheet: false,
      packages: [],
      selectedPackage: null,
      paying: false,
      showToast: false,
      toastType: 'success',
      toastMessage: ''
    }
  },
  computed: {
    displayPrivileges() {
      const icons = ['music-o', 'gem-o', 'clock-o', 'service-o', 'star-o', 'coupon-o']
      const colors = ['#1890ff', '#722ed1', '#fa8c16', '#52c41a', '#2f54eb', '#eb2f96']
      const bgs = [
        'rgba(24, 144, 255, 0.1)',
        'rgba(114, 46, 209, 0.1)',
        'rgba(250, 140, 22, 0.1)',
        'rgba(82, 196, 26, 0.1)',
        'rgba(47, 84, 235, 0.1)',
        'rgba(235, 47, 150, 0.1)'
      ]
      const pkg = this.selectedPackageObj
      let lines = []
      if (pkg && Array.isArray(pkg.features) && pkg.features.length) {
        lines = pkg.features.slice()
      } else if (this.packages.length) {
        const all = []
        this.packages.forEach(p => {
          (p.features || []).forEach(t => {
            if (t && all.indexOf(t) === -1) all.push(t)
          })
        })
        lines = all
      }
      return lines.map((text, index) => ({
        icon: icons[index % icons.length],
        title: text,
        desc: '',
        color: colors[index % colors.length],
        bgColor: bgs[index % bgs.length]
      }))
    },
    selectedPackageObj() {
      if (!this.selectedPackage) return null
      return this.packages.find(p => p.id === this.selectedPackage) || null
    },
    user() {
      return this.$store.state.user || {}
    },
    bankVipTierLevel() {
      const bank = this.selectedBank
      if (bank && bank.has_access) {
        return bankEntitlementLevel(bank) || 0
      }
      return 0
    },
    vipText() {
      const bank = this.selectedBank
      if (bank && bank.has_access) {
        return resolveBankVipDisplayName(bank) || '已开通'
      }
      if (this.bankId > 0) {
        return '免费体验'
      }
      const bankVips = (this.user.bank_vips || []).filter((v) => v && v.has_access)
      if (bankVips.length) {
        return bankVips[bankVips.length - 1].package_name || '已开通'
      }
      return '免费体验'
    },
    vipDesc() {
      const bank = this.selectedBank
      if (bank && bank.has_access) {
        const pkg = bank.entitlement_package_name
        const exp = bank.expire_text
        if (exp === '永久') {
          return pkg ? (pkg + ' · 永久有效') : '永久有效'
        }
        if (exp) {
          return pkg ? (pkg + ' · 有效期至 ' + exp) : ('有效期至 ' + exp)
        }
        return pkg || '本题库已开通'
      }
      if (bank && bank.purchase_blocked) {
        return '您已开通更高等级题库，本题库不可再购'
      }
      return '选择下方套餐开通本题库会员'
    },
    vipExpireText() {
      if (!this.user.vip_end_time || this.user.vip_end_time === 0) {
        return this.user.vip_level > 0 ? '永久有效' : ''
      }
      const expireDate = new Date(this.user.vip_end_time * 1000)
      const year = expireDate.getFullYear()
      const month = (expireDate.getMonth() + 1).toString().padStart(2, '0')
      const day = expireDate.getDate().toString().padStart(2, '0')
      return `有效期至 ${year}.${month}.${day}`
    },
    vipIcon() {
      const icons = {
        0: 'user-circle-o',
        1: 'star-o',
        2: 'fire-o',
        3: 'gem-o',
        4: 'diamond-o'
      }
      return icons[this.bankVipTierLevel] || 'user-circle-o'
    },
    previewFeatures() {
      const icons = ['music-o', 'gem-o', 'clock-o', 'service-o']
      const pkg = this.selectedPackageObj
      let texts = []
      if (pkg && pkg.features && pkg.features.length) {
        texts = pkg.features.slice(0, 4)
      } else if (this.packages.length) {
        const p = this.packages[this.packages.length - 1]
        texts = (p.features || []).slice(0, 4)
      }
      return texts.map((text, i) => ({
        icon: icons[i % icons.length],
        text
      }))
    },
    privileges() {
      return this.displayPrivileges
    },
    selectedPackagePrice() {
      if (!this.selectedPackage) return '0'
      const pkg = this.packages.find(p => p.id === this.selectedPackage)
      return pkg ? parseFloat(pkg.price).toFixed(2) : '0'
    },
    selectedBank() {
      return this.banks.find(b => b.id === this.bankId) || null
    },
    bankActions() {
      return this.banks.map(b => ({
        name: b.name + (b.has_access ? '（已开通）' : ''),
        disabled: !!b.purchase_blocked,
        bank: b
      }))
    },
    bankVipActive() {
      const bank = this.selectedBank
      return !!(bank && bank.has_access)
    },
    canSelectPackage() {
      if (!this.selectedPackage) return false
      const pkg = this.packages.find(p => p.id === this.selectedPackage)
      if (!pkg) return false
      return !this.isPackageDisabled(pkg)
    }
  },
  async mounted() {
    this.bankId = parseInt(this.$route.query.bank_id, 10) || 0
    this.bankName = this.$route.query.bank_name || ''
    if (this.$store.state.token) {
      await this.$store.dispatch('fetchUserInfo')
    }
    await this.loadBanks()
    await this.loadPackages()
  },
  activated() {
    if (this.$store.state.token) {
      this.$store.dispatch('fetchUserInfo').then(() => {
        this.loadBanks().then(() => this.loadPackages())
      })
    }
  },
  methods: {
    packageFeatureTags(pkg) {
      if (pkg && Array.isArray(pkg.features) && pkg.features.length) {
        return pkg.features
      }
      if (pkg && pkg.description) {
        return [pkg.description]
      }
      return []
    },
    formatPrice(price) {
      const n = parseFloat(price)
      if (isNaN(n)) return '0'
      if (Math.abs(n - Math.round(n)) < 0.001) {
        return String(Math.round(n))
      }
      return n.toFixed(2)
    },
    goBack() {
      const backRoute = this.$store.getters.smartBackRoute
      this.$router.push(backRoute)
    },
    async loadBanks() {
      try {
        const data = await this.$store.dispatch('fetchQuestionBanks')
        this.banks = data.banks || []
        this.maxOwnedLevel = data.maxOwnedLevel || 0
        if (this.bankId) {
          const cur = this.banks.find(b => b.id === this.bankId)
          if (cur) this.applyBank(cur, false)
        } else {
          const lastId = parseInt(localStorage.getItem('last_bank_id'), 10) || 0
          const picked = this.banks.find(b => b.id === lastId) || this.banks[0]
          if (picked) this.applyBank(picked, false)
        }
      } catch (e) {
        console.error(e)
      }
    },
    applyBank(bank, reloadRoute = true) {
      if (!bank) return
      this.bankId = bank.id
      this.bankName = bank.name
      this.bankPurchaseBlocked = !!bank.purchase_blocked
      this.entitlementPackageId = parseInt(bank.entitlement_package_id, 10) || 0
      localStorage.setItem('last_bank_id', String(bank.id))
      if (reloadRoute) {
        this.$router.replace({ path: '/vip', query: { bank_id: bank.id, bank_name: bank.name } }).catch(() => {})
      }
    },
    onBankSheetSelect(action) {
      if (action && action.bank) {
        this.onBankSelect(action.bank)
      }
      this.showBankSheet = false
    },
    onBankSelect(bank) {
      if (bank.purchase_blocked) {
        this.showToastMessage('您已开通' + this.maxOwnedLevel + '级题库，无法再购买更低等级', 'fail')
        return
      }
      this.applyBank(bank)
      this.selectedPackage = null
      this.loadPackages()
    },
    mapRawPackages(list) {
      const byLevel = {}
      ;(list || []).forEach(pkg => {
        if (parseInt(pkg.status, 10) !== 1) return
        const level = parseInt(pkg.level, 10)
        if (level < 1) return
        const sort = parseInt(pkg.sort, 10) || level
        const id = parseInt(pkg.id, 10)
        const prev = byLevel[level]
        if (!prev || sort > prev._sort || (sort === prev._sort && id > prev.id)) {
          byLevel[level] = { pkg, _sort: sort, id }
        }
      })
      return Object.keys(byLevel)
        .map(k => parseInt(k, 10))
        .sort((a, b) => a - b)
        .map(level => {
          const pkg = byLevel[level].pkg
          return {
            id: parseInt(pkg.id, 10),
            name: pkg.name,
            level,
            days: parseInt(pkg.valid_days, 10),
            price: pkg.price,
            original_price: pkg.original_price,
            color: pkg.color || '#52c41a',
            icon: pkg.icon || 'star-o',
            valid_type: parseInt(pkg.valid_type, 10),
            description: pkg.description || '',
            features: Array.isArray(pkg.features) ? pkg.features : []
          }
        })
    },
    async loadPackages() {
      try {
        const params = this.bankId > 0 ? { bank_id: this.bankId } : {}
        const response = await this.$http.get('/api/vip/packages', { params })
        let raw = (response.data.data && response.data.data.packages) || []
        let mapped = this.mapRawPackages(raw)

        if (mapped.length === 0 && this.bankId > 0) {
          const data = await this.$store.dispatch('fetchQuestionBanks')
          this.banks = data.banks || []
          const bank = this.banks.find(b => b.id === this.bankId)
          if (bank) {
            this.applyBank(bank, false)
            const fromBank = this.mapRawPackages(bank.packages || [])
            if (fromBank.length > mapped.length) {
              mapped = fromBank
            }
          }
          if (mapped.length === 0) {
            const retry = await this.$http.get('/api/vip/packages', { params })
            raw = (retry.data.data && retry.data.data.packages) || []
            mapped = this.mapRawPackages(raw)
          }
        }

        this.packages = mapped
        if (this.selectedPackage && !this.packages.some(p => p.id === this.selectedPackage)) {
          this.selectedPackage = null
        }
        if (this.packages.length === 0) {
          this.showToastMessage('本题库暂无套餐，请联系管理员在后台执行「为题库生成套餐」', 'fail')
        }
      } catch (err) {
        this.showToastMessage('加载套餐失败', 'fail')
      }
    },
    selectPackage(pkg) {
      if (this.isPackageDisabled(pkg)) {
        if (this.bankPurchaseBlocked) {
          this.showToastMessage('您已开通更高等级题库，无法再购买本题库', 'fail')
        } else {
          this.showToastMessage('当前VIP等级已达到或高于此套餐', 'fail')
        }
        return
      }
      this.selectedPackage = pkg.id
    },
    isPackageDisabled(pkg) {
      if (this.bankId > 0) {
        if (this.bankPurchaseBlocked) {
          return true
        }
        const bank = this.selectedBank
        if (bank && bank.has_access) {
          const entLevel = bankEntitlementLevel(bank)
          if (entLevel > 0 && parseInt(pkg.level, 10) <= entLevel) {
            return true
          }
        }
        return false
      }
      if (!this.user.vip_level || this.user.vip_level === 0) {
        return false
      }
      const currentLevel = parseInt(this.user.vip_level)
      const pkgLevel = parseInt(pkg.level)
      return currentLevel >= pkgLevel
    },
    isPackageCurrent(pkg) {
      if (this.bankId > 0) {
        const bank = this.selectedBank
        if (!bank || !bank.has_access) {
          return false
        }
        if (this.entitlementPackageId > 0) {
          return pkg.id === this.entitlementPackageId
        }
        const entLevel = bankEntitlementLevel(bank)
        return entLevel > 0 && parseInt(pkg.level, 10) === entLevel
      }
      if (!this.user.vip_level || this.user.vip_level === 0) {
        return false
      }
      const currentLevel = parseInt(this.user.vip_level)
      const pkgLevel = parseInt(pkg.level)
      return currentLevel === pkgLevel
    },
    showToastMessage(message, type = 'success') {
      this.toastMessage = message
      this.toastType = type
      this.showToast = true
    },
    async handleBuy() {
      if (this.bankId <= 0 && this.banks.length > 0) {
        this.showToastMessage('请先选择题库', 'fail')
        return
      }
      if (this.bankPurchaseBlocked) {
        this.showToastMessage('您已开通更高等级题库，无法再购买本题库', 'fail')
        return
      }
      if (!this.selectedPackage) {
        this.showToastMessage('请选择套餐', 'fail')
        return
      }

      this.paying = true
      
      try {
        const response = await this.$http.post('/api/vip/buy', {
          package_id: this.selectedPackage
        })
        
        const orderNo = response.data.data.order_no
        const jsApiParams = response.data.data.jsApiParams
        
        if (typeof WeixinJSBridge !== 'undefined') {
          WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiParams, async (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.showToastMessage('支付成功，正在开通会员…')
              await syncOrderPayAfterWxSuccess(this.$http, orderNo)
              await this.$store.dispatch('fetchUserInfo')
              await this.loadBanks()
              await this.loadPackages()
              this.paying = false
              this.showToastMessage('会员已开通')
              setTimeout(() => {
                this.$router.back()
              }, 1200)
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              this.paying = false
              this.showToastMessage('支付已取消', 'fail')
            } else {
              this.paying = false
              this.showToastMessage('支付失败', 'fail')
            }
          })
        } else {
          this.showToastMessage('请在微信中打开', 'fail')
          this.paying = false
        }
      } catch (err) {
        this.paying = false
        this.showToastMessage(err.message || '支付失败', 'fail')
      }
    }
  }
}
</script>

<style scoped>
.vip-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f2f5 0%, #e8ecf0 100%);
  padding-bottom: calc(220px + env(safe-area-inset-bottom));
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08), rgba(118, 75, 162, 0.08));
}

.bg-circle-1 {
  width: 500px;
  height: 500px;
  top: -200px;
  right: -150px;
}

.bg-circle-2 {
  width: 400px;
  height: 400px;
  bottom: 400px;
  left: -150px;
}

.bg-circle-3 {
  width: 300px;
  height: 300px;
  top: 600px;
  right: -100px;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding-top: env(safe-area-inset-top);
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
}

.header-content {
  display: flex;
  /* align-items: center; */
  padding: 16px 0px;
}

.header-left {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-center {
  flex: 1;
  text-align: center;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.header-right {
  width: 44px;
}

.bank-switch-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.bank-switch-label {
  font-size: 13px;
  color: #888;
}
.bank-switch-value {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  text-align: right;
}

.content {
  padding: 20px 16px;
  position: relative;
  z-index: 5;
}

.vip-hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 24px;
  padding: 28px 24px;
  margin-bottom: 28px;
  position: relative;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.hero-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.vip-icon-wrapper {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.vip-icon-wrapper .van-icon {
  color: white;
}

.vip-icon-0 {
  background: rgba(255, 255, 255, 0.15);
}

.vip-icon-1 {
  background: rgba(24, 144, 255, 0.3);
  border-color: rgba(24, 144, 255, 0.5);
}

.vip-icon-2 {
  background: rgba(47, 84, 235, 0.3);
  border-color: rgba(47, 84, 235, 0.5);
}

.vip-icon-3 {
  background: rgba(114, 46, 209, 0.3);
  border-color: rgba(114, 46, 209, 0.5);
}

.vip-icon-4 {
  background: rgba(250, 140, 22, 0.3);
  border-color: rgba(250, 140, 22, 0.5);
}

.vip-info {
  flex: 1;
}

.vip-title {
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0 0 4px 0;
}

.vip-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.vip-status {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.vip-status.active {
  background: rgba(82, 196, 26, 0.3);
  color: white;
}

.vip-features-preview {
  display: flex;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 1;
}

.preview-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.section-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

.section-tip {
  font-size: 13px;
  color: #8c8c8c;
}

.packages {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-bottom: 28px;
}

.package-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  opacity: 0;
  animation: card-fade-in 0.5s ease-out forwards;
}

@keyframes card-fade-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.package-card.selected {
  border-color: #667eea;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.25);
}

.package-card.current {
  background: linear-gradient(180deg, #f8f9ff 0%, #f0f2ff 100%);
}

.package-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.package-card:active:not(.disabled) {
  transform: scale(0.98);
}

.package-popular-tag {
  position: absolute;
  top: 12px;
  right: -24px;
  background: linear-gradient(135deg, #fa8c16 0%, #d46b08 100%);
  color: white;
  font-size: 10px;
  padding: 4px 28px;
  transform: rotate(45deg);
  font-weight: 600;
}

.package-header {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #999 0%, #666 100%);
}

.package-header.pkg-level-1 {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
}

.package-header.pkg-level-2 {
  background: linear-gradient(135deg, #2f54eb 0%, #1d39c4 100%);
}

.package-header.pkg-level-3 {
  background: linear-gradient(135deg, #722ed1 0%, #531dab 100%);
}

.package-header.pkg-level-4 {
  background: linear-gradient(135deg, #fa8c16 0%, #d46b08 100%);
}

.package-level-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  color: white;
}

.package-level-badge .van-icon {
  color: rgba(255, 255, 255, 0.8);
}

.package-level-badge span {
  font-size: 16px;
  font-weight: 700;
}

.package-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.current-tag {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: transparent !important;
  color: white !important;
}

.package-body {
  padding: 16px;
}

.package-price-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 8px;
}

.currency {
  font-size: 14px;
  color: #fa8c16;
  font-weight: 600;
}

.price {
  font-size: 28px;
  font-weight: 700;
  color: #fa8c16;
}

.original {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
  margin-left: 4px;
}

.package-duration {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #8c8c8c;
}

.package-footer {
  padding: 0 16px 16px;
}

.package-features-mini {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.feature-tag {
  font-size: 11px;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  color: #666;
}

.package-desc-line {
  font-size: 11px;
  color: #999;
  margin: 8px 0 0;
  line-height: 1.4;
}

.package-card.selected .feature-tag {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

.package-select-indicator {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.privileges-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-bottom: 24px;
}

.privilege-card {
  background: white;
  border-radius: 16px;
  padding: 20px 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  opacity: 0;
  animation: scale-in 0.4s ease-out forwards;
}

@keyframes scale-in {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.privilege-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.privilege-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 4px 0;
}

.privilege-card p {
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
}

.tips-section {
  margin-bottom: 20px;
}

.tips-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: linear-gradient(135deg, #fff7e6 0%, #fff5e6 100%);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #ffd591;
}

.tips-content {
  flex: 1;
}

.tips-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 4px 0;
}

.tips-text {
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
  line-height: 1.5;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  z-index: 100;
}

.footer-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.total-price {
  display: flex;
  flex-direction: column;
}

.total-price .label {
  font-size: 12px;
  color: #8c8c8c;
}

.total-price .amount {
  font-size: 24px;
  font-weight: 700;
  color: #fa8c16;
}

.buy-btn {
  flex: 1;
  height: 52px;
  font-size: 17px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.buy-btn:disabled {
  background: #d9d9d9;
}

@keyframes animate-fade-in-up {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: animate-fade-in-up 0.5s ease-out forwards;
}

.animate-scale-in {
  animation: scale-in 0.4s ease-out forwards;
}
</style>
